<div class="relative mt-8 flex flex-auto flex-col items-center gap-8">
  @if (subscription(); as sub) {
    <div class="w-full max-w-3xl">
      <!-- Summary Card -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-gray-5 p-6 shadow-sm">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Abonnement</span>
            <h1 class="text-2xl font-bold text-gray-12">{{ sub.plan.name || 'Sans offre' }}</h1>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-2.5 py-1 text-sm font-medium"
            >
              <div
                class="size-2 rounded-full"
                [class.bg-green-9]="sub.status === 'active' || sub.status === 'trialing'"
                [class.bg-amber-9]="sub.status === 'past_due' || sub.status === 'paused'"
                [class.bg-red-9]="sub.status === 'canceled' || sub.status === 'unpaid'"
                [class.bg-neutral-9]="sub.status === 'incomplete' || sub.status === 'incomplete_expired'"
              ></div>
              {{ sub.status | subscriptionStatusDisplay }}
            </div>

            @if (canCancel()) {
              <button
                mat-button
                class="primary destructive"
                [disabled]="isCancelling()"
                (click)="cancelSubscription()"
              >
                <mat-icon class="mr-2">cancel</mat-icon>
                {{ isCancelling() ? 'Annulation...' : 'Annuler' }}
              </button>
            }
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Details Grid -->
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Left side: User and Price -->
          <div class="flex flex-col gap-4">
            @if (sub.user) {
              <div class="flex flex-col gap-2">
                <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Abonné</span>
                <a
                  [routerLink]="['/users', sub.user._id]"
                  class="link flex flex-row items-center !p-0 !h-auto !min-w-0 cursor-pointer"
                >
                  <aura-avatar
                    [label]="sub.user.identity.firstName || ''"
                    [srcImage]="$safeNavigationMigration(sub.user.identity.avatar?.url)"
                    [size]="'s'"
                  />
                  <div class="ml-3 text-left">
                    <div class="font-medium text-gray-12">
                      {{ sub.user.identity.firstName }} {{ sub.user.identity.lastName }}
                    </div>
                    <div class="text-xs text-gray-10">{{ sub.user.contactInfos.email }}</div>
                  </div>
                </a>
              </div>
            }

            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Tarif</span>
              <div class="text-lg font-semibold text-gray-12">
                @if (sub.plan) {
                  {{ sub.plan.price | priceDisplay: sub.plan.currency }} / {{ sub.plan.billingCycle }}
                } @else {
                  -
                }
              </div>
            </div>
          </div>

          <!-- Right side: Dates -->
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Période en cours</span>
              <div class="text-sm text-gray-12">
                Du {{ sub.currentPeriodStart | luxonDate: 'dd/LL/yyyy HH:mm' }}<br />
                Au {{ sub.currentPeriodEnd | luxonDate: 'dd/LL/yyyy HH:mm' }}
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
                >Annulation en fin de période</span
              >
              <div>
                @if (sub.cancelAtPeriodEnd) {
                  <span
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-red-a3 px-2 py-0.5 text-xs font-medium text-red-11"
                  >
                    Oui
                  </span>
                } @else {
                  <span
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-green-a3 px-2 py-0.5 text-xs font-medium text-green-11"
                  >
                    Non
                  </span>
                }
              </div>
            </div>
          </div>
        </div>

        @if (sub.metadata?.stripe; as stripe) {
          <mat-divider></mat-divider>

          <!-- Metadata -->
          <div class="flex flex-col gap-4">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
              >Informations Stripe</span
            >
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div class="flex flex-col gap-1">
                <span class="text-xs text-gray-10">ID de l'abonnement Stripe</span>
                <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.subscriptionId }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs text-gray-10">ID du client Stripe</span>
                <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.customerId }}</span>
              </div>
            </div>
          </div>
        }

        <mat-divider></mat-divider>

        <!-- Metadata / Timeline -->
        <div class="flex flex-col gap-2 md:flex-row md:justify-between text-xs text-gray-9">
          <div>Créé le : {{ sub.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
          <div>Mis à jour le : {{ sub.updatedAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
        </div>
      </div>
    </div>
  }
</div>
